import { useQuizStore } from "@/stores/quiz-store"

import { getOnboardingQuizId } from "./quiz-id-storage"
import { mapQuizToLockTarget } from "./map-quiz-to-target"
import { useOnboardingLockStore } from "./onboarding-lock-store"

/**
 * Start the 30‑min onboarding lock once on first webapp entry.
 * No-op if already started, skipped, or quiz type is unknown.
 */
export function startOnboardingLockIfNeeded(): void {
  const quizId =
    getOnboardingQuizId() ?? useQuizStore.getState().activeQuizId ?? null
  const target = mapQuizToLockTarget(quizId)
  if (!target) return
  useOnboardingLockStore.getState().start(target)
}
